import React from 'react'
import { groupDependentFields } from '../../common/utils'
import { formatFieldWithKeys } from '../../selectors/RiskAssessments'
import FormFields from './FormFields'

interface FormProps {
  formId: string
  fields: Record<string, any>
  form: any
  readOnly?: boolean
  style?: React.CSSProperties
  noLeftMargin?: any
  required?: any
}

const Form: React.FC<FormProps> = ({ formId, fields, form, ...props }) => {
  const withKeys = form.map(formatFieldWithKeys)
  const formFields = groupDependentFields(withKeys)
  return (
    <FormFields
      userGenerated
      // @ts-ignore
      form={{ formFields }}
      formId={formId}
      fields={fields}
      type="userGenerated"
      {...props}
    />
  )
}

export default Form
